import { render, staticRenderFns } from "./SangomaAIAssistanceCTAButton.vue?vue&type=template&id=31b0fbaa&scoped=true&"
import script from "./SangomaAIAssistanceCTAButton.vue?vue&type=script&lang=js&"
export * from "./SangomaAIAssistanceCTAButton.vue?vue&type=script&lang=js&"
import style0 from "./SangomaAIAssistanceCTAButton.vue?vue&type=style&index=0&id=31b0fbaa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b0fbaa",
  null
  
)

export default component.exports